export const AnnouncementBar = () => {
  const msg =
    "🔥 TODAY'S OFFER: Big Discount + Cash On Delivery (COD) Available + Fast Delivery in 2 to 4 Days 🔥";
  return (
    <div className="overflow-hidden bg-[var(--hp-crimson-dark)] py-2 text-white">
      <div className="hp-marquee-track text-xs sm:text-sm font-semibold tracking-wide">
        <span className="px-8">{msg}</span>
        <span className="px-8">{msg}</span>
        <span className="px-8">{msg}</span>
        <span className="px-8">{msg}</span>
      </div>
    </div>
  );
};
